import React from 'react';
import PropTypes from 'prop-types';
import { payoutStatus } from './PayoutsUtils';
import { get, isEmpty } from 'lodash';
import classnames from 'classnames';
import moment from 'moment';
import { injectIntl, intlShape, FormattedMessage, FormattedDate } from 'react-intl';

const PayoutsRow = ({ payout, isCollapseOpen, intl }) => {
  const {
    bank_account = {},
    number_of_items = '',
    max_payout_processed_date = '',
    method_desc = ''
  } = payout;
  const totalAmount = get(payout, 'total_amount.display_string', '');
  const { name: bankName = '', last4 = '' } = bank_account;
  const arrow = classnames('ico ico-sm icon-arrow-nav text-gray-500', { 'icon-rotate-180': isCollapseOpen });
  const status = get(payoutStatus, [payout.status], {});

  return (
    <div className="flex">
      <div className="flex-basis-15 flex-basis-45-xxs">
        <FormattedDate
          value={moment(max_payout_processed_date)}
          year="numeric"
          month="long"
          day="2-digit"
        />
      </div>
      <div className="flex-basis-15 hidden-xs">
        <span className={`status-${status.class}`}>{intl.formatMessage(status.text)}</span>
      </div>
      <div className="flex-basis-40 hidden-xxs">
        { !isEmpty(bank_account) ? <FormattedMessage id="hosting.payouts_row.payout_bank_text" defaultMessage="Payout to {bankName} ••••{last4}" values={{ bankName: bankName, last4: last4 }}/> : method_desc }
      </div>
      <div className="flex-basis-10 text-right hidden-xs">
        { number_of_items }
      </div>
      <div className="flex-basis-15 flex-basis-45-xxs text-right heavy">
        {totalAmount}
      </div>
      <div className="flex-basis-5 flex-basis-10-xxs text-right">
        <i className={arrow} />
      </div>
    </div>
  );
};

PayoutsRow.propTypes = {
  payout: PropTypes.object.isRequired,
  isCollapseOpen: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(PayoutsRow);
